export default __webpack_public_path__ + "static/media/CelularComInfoKahsh.0595acb2.png";